<template>
  <b-modal
    ref="customCodeModal"
    hide-footer
    centered
    title="Create custom code"
    >
    <b-form @submit.prevent="create" novalidate>
      <b-form-group
        label="File name:"
        >
        <b-form-input
          ref="fileNameInput"
          type="text"
          autocomplete="off"
          v-model.trim="$v.fileName.$model"
          :class="{ 'is-invalid': $v.fileName.$error }"
          :disabled="inProgress"
          />
        <b-form-invalid-feedback v-if="!$v.fileName.required">File name is required</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        label="Scope:"
        >
        <b-form-select v-model="selectedScope" :options="scopes" />
      </b-form-group>
      <b-button
        type="submit"
        >
        Create
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'

let $ = window.$

export default {
  data () {
    return {
      inProgress: false,
      fileName: '',
      type: '',
      tabs: null,
      selectedScope: null
    }
  },
  computed: {
    scopes () {
      let scopes = [
        {
          value: null,
          text: 'Global'
        }
      ]
      if (this.tabs) {
        let vm = this
        for (let tab in this.tabs) {
          let scope = {
            value: tab,
            text: vm.tabs[tab].title
          }
          scopes.push(scope)
        }
      }
      return scopes
    }
  },
  methods: {
    create () {
      if (this.inProgress) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.inProgress = true

      let vm = this
      let payload = {
        name: vm.fileName,
        type: vm.type,
        scope: vm.selectedScope
      }

      db.customCode.create(payload, (key) => {
        if (this.$refs.customCodeModal) this.$refs.customCodeModal.hide()
        this.fileName = ''
        this.type = ''
        this.selectedScope = null
        this.$nextTick(() => {
          this.$v.$reset()
        })
        this.$store.commit('editCustomCode', {
          key,
          insert: true
        })
        this.inProgress = false
      })
    }
  },
  created () {
    eventBus.$on('showCustomCodeModal', (type) => {
      this.type = type

      if (this.$refs.customCodeModal) {
        this.$refs.customCodeModal.show()
        setTimeout(() => {
          this.$refs.fileNameInput.focus()
        })
      }
    })

    db.tabs.read((tabs) => {
      this.tabs = tabs
    })
  },
  validations: {
    fileName: {
      required
    }
  },
  mounted () {
    if (this.$refs.customCodeModal) {
      $(this.$refs.customCodeModal['$el']).appendTo('body')
    }
  },
  beforeDestroy () {
    if (this.$refs.customCodeModal) {
      $(this.$refs.customCodeModal['$el']).remove()
    }
  }
}
</script>
